import { Country, Language } from "@imagine/frontend-base";
import { ImagineConfig } from "@imagine/config";
import { SentryReporter } from "..";

const getBrowserLanguage = () => {
  if (window.navigator.language) return navigator.language;
  return ImagineConfig.defaultLanguage;
};

const getLanguageUrlPrefix = (language: Language) => {
  const languageUrl = ImagineConfig.languageUrlMap.find(
    (languageUrl) => languageUrl.language === language,
  );
  if (!languageUrl) {
    console.error("No language URL map found for language: " + language);
    return "";
  }
  return languageUrl.urlPrefix;
};

const getLanguageFromUrlPrefix = (urlPrefix: string) => {
  const languageUrl = ImagineConfig.languageUrlMap.find(
    (languageUrl) => languageUrl.urlPrefix === urlPrefix,
  );
  if (!languageUrl) {
    console.error("No language URL map found for URL prefix: " + urlPrefix);
    return ImagineConfig.defaultLanguage as Language;
  }
  return languageUrl.language as Language;
};

/**
 * Get the country of the user based on their IP address.
 * @param fallbackCountry Fallback country in case user country is not supported. IF not set, the user country will be returned regardsless of support.
 * @returns
 */
const getUserCountry = async (fallbackCountry?: Country) => {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const json = await response.json();
    if (json.country) {
      const supportedCountries = ImagineConfig.supportedCountries;
      if (supportedCountries.includes(json.country)) {
        return json.country as Country;
      } else {
        if (fallbackCountry) return fallbackCountry;
        return json.country;
      }
    }
    return fallbackCountry;
  } catch (e) {
    console.error("Could not get user location: ", e);
    SentryReporter.captureException(e);
    return fallbackCountry;
  }
};

const getUserLocationInfo = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/");
    return await response.json();
  } catch (e) {
    console.error("Could not get user location: ", e);
    SentryReporter.captureException(e);
    return {};
  }
};

export const I18nToolsWeb = {
  getBrowserLanguage,
  getLanguageUrlPrefix,
  getLanguageFromUrlPrefix,
  getUserCountry,
  getUserLocationInfo,
};
